var map = {
	"./2025-10-02/summary.md": 70000,
	"./2025-10-15/summary.md": 79364,
	"./2025-11-05/summary.md": 78920,
	"./2025-11-15/summary.md": 95413,
	"./2025-11-25/summary.md": 52274
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 63836;